/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M4.2101 1 0 14h5.0072L2 23h17.7899L24 10h-5.0072L22 1H4.2101Zm14.1812 11-.6014 2H7.0957L4.69 21h13.6129l3.0073-9h-2.9188ZM2.6899 12l3.0073-9H19.31l-3.0073 9H2.6899Z"
    clipRule="evenodd"
  />,
  'DataPlanes'
);
